/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './package-subscription-discount.reducer';

export const PackageSubscriptionDiscount = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const packageSubscriptionDiscountList = useAppSelector(state => state.packageSubscriptionDiscount.entities);
  const loading = useAppSelector(state => state.packageSubscriptionDiscount.loading);
  const totalItems = useAppSelector(state => state.packageSubscriptionDiscount.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="package-subscription-discount-heading" data-cy="PackageSubscriptionDiscountHeading">
        <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.home.title">Package Subscription Discounts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/package-subscription-discount/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.home.createLabel">
              Create new Package Subscription Discount
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.packageSubscriptionDiscount.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {packageSubscriptionDiscountList && packageSubscriptionDiscountList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('actualDiscount')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.actualDiscount">Actual Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actualDiscount')} />
                </th>
                <th className="hand" onClick={sort('billNumber')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.billNumber">Bill Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billNumber')} />
                </th>
                <th className="hand" onClick={sort('billDate')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.billDate">Bill Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billDate')} />
                </th>
                <th className="hand" onClick={sort('billType')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.billType">Bill Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billType')} />
                </th>
                <th className="hand" onClick={sort('billId')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.billId">Bill Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billId')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('remarks')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.remarks">Remarks</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remarks')} />
                </th>
                <th className="hand" onClick={sort('exception')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.exception">Exception</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exception')} />
                </th>
                <th className="hand" onClick={sort('billOrigin')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.billOrigin">Bill Origin</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billOrigin')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.usedBy">Used By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {packageSubscriptionDiscountList.map((packageSubscriptionDiscount, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/package-subscription-discount/${packageSubscriptionDiscount.id}`} color="link" size="sm">
                      {packageSubscriptionDiscount.id}
                    </Button>
                  </td>
                  <td>{packageSubscriptionDiscount.discount}</td>
                  <td>{packageSubscriptionDiscount.actualDiscount}</td>
                  <td>{packageSubscriptionDiscount.billNumber}</td>
                  <td>{packageSubscriptionDiscount.billDate}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BillType.${packageSubscriptionDiscount.billType}`} />
                  </td>
                  <td>{packageSubscriptionDiscount.billId}</td>
                  <td>{packageSubscriptionDiscount.active ? 'true' : 'false'}</td>
                  <td>{packageSubscriptionDiscount.cursor}</td>
                  <td>{packageSubscriptionDiscount.lastUpdated}</td>
                  <td>{packageSubscriptionDiscount.microSec}</td>
                  <td>{packageSubscriptionDiscount.timestampEntry}</td>
                  <td>{packageSubscriptionDiscount.remarks}</td>
                  <td>{packageSubscriptionDiscount.exception ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BillOrigin.${packageSubscriptionDiscount.billOrigin}`} />
                  </td>
                  <td>
                    {packageSubscriptionDiscount.usedBy ? (
                      <Link to={`/package-subscriber/${packageSubscriptionDiscount.usedBy.id}`}>
                        {packageSubscriptionDiscount.usedBy.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/package-subscription-discount/${packageSubscriptionDiscount.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/package-subscription-discount/${packageSubscriptionDiscount.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/package-subscription-discount/${packageSubscriptionDiscount.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.packageSubscriptionDiscount.home.notFound">
                No Package Subscription Discounts found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={packageSubscriptionDiscountList && packageSubscriptionDiscountList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PackageSubscriptionDiscount;
